import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Button } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
import { ArrowRight } from '../../../assets/icons';
import { formatSSN } from '../../../utils/formatSSN';
import { updateUserProfile } from '../../../services/authApi/userApi';
import { ssnRegex } from '../../../utils/Validations';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import { toastNotify } from '../../../utils/toastNotify';
import { check150YearValid } from '../../../utils/checkYearValid';
import { allowOnlyFourDigit } from '../../../utils/allowOnlyFourDigit';
import { preventReload } from '../../../utils/preventReload';
import { addUserData } from '../../../store/reducer/accountSlice';

const StepThree = (props) => {
  const [ssn, setSsn] = useState();
  const [month, setMonth] = useState();
  const [day, setDay] = useState();
  const [year, setYear] = useState();
  const [form] = Form.useForm();
  const [loading, setLoaing] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const { userProfileData } = useGetUserProfile();
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(userProfileData).length > 0 && userProfileData.ssn !== null && userProfileData.dob) {
      const day = userProfileData?.dob.slice(3, 5);
      const month = userProfileData?.dob.slice(0, 2);
      const year = userProfileData?.dob.slice(6, 10);
      if (day && month && year) {
        form.setFieldsValue({
          ssn: userProfileData?.ssn,
          year: year,
          day: day,
          month: month,
        });
        setSsn(userProfileData?.ssn);
        setDay(day);
        setMonth(month);
        setYear(year);
      }
      setEdit(true);
    }
  }, [userProfileData]);
  useEffect(() => {
    preventReload(form);
  }, []);

  const handleInput = (e) => {
    const { value } = e.target;
    // this is where we'll call the formatSSN function
    const formattedSSN = formatSSN(value);
    // we'll set the input value using our setFieldsValue
    form.setFieldValue('ssn', formattedSSN);
    setSsn(formattedSSN);
  };

  const onStepThreeSubmit = async (values) => {
    //convert formate ssn number into normal number xxx-xx-xxxx to xxxxxx"
    setLoaing(true);
    // const ssnInput = `${values.ssn.slice(0, 3)}${values.ssn.slice(4, 6)}${values.ssn.slice(7, 11)}`;
    const dobInput = `${values.month}/${values.day}/${values.year}`;

    const formThreeData = {
      ssn: values.ssn,
      dob: dobInput,
    };

    try {
      const resp = await updateUserProfile(formThreeData);
      if (!resp.isError) {
        !isEdit ? props.nextAction('StepFour') : props.nextAction('StepSix');
        dispatch(addUserData({ userData: resp?.data?.user }));
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoaing(false);
    }
  };

  const moveFocusToTheNextField = (valueLength, length, fieldName) => {
    if (valueLength === length) {
      const nextfield = document.querySelector(`input[name=${fieldName}]`);
      nextfield.focus();
    }
  };

  const handleSetMonth = (value) => {
    setMonth(value);
    moveFocusToTheNextField(value.length, 2, 'day');
  };

  const handleSetDay = (value) => {
    setDay(value);
    moveFocusToTheNextField(value.length, 2, 'year');
    // moveFocusToTheNextField(value.length, 0, 'month');
  };

  const handleSetYear = (value) => {
    const yearInput = allowOnlyFourDigit(value);
    form.setFieldValue('year', yearInput);
    setYear(yearInput);

    return `${month}/${day}/${yearInput}`;

    // check150YearValid(dateStr)
    // moveFocusToTheNextField(value.length, 0, 'day');
  };
  return (
    <Form
      form={form}
      name='stepThreeForm'
      className='auth-form stepthree'
      onFinish={onStepThreeSubmit}
      onKeyPress={(e) => {
        if (e.key === 'Enter' && !(!form.isFieldsTouched(true) || !!form.getFieldsError().filter(({ errors }) => errors.length).length)) {
          form.submit();
        }
      }}
      autoComplete='off'
    >
      <FloatingLabel label='Social security number' inputId='ssn' isEdit={isEdit} inputValue={ssn}>
        <Form.Item
          validateTrigger="onBlur"
          name='ssn'
          rules={[
            {
              required: true,
              transform: (value) => formatSSN(value),
              pattern: ssnRegex,
              message: 'Enter a valid SSN',
            },
          ]}
        >
          <Input id='ssn' maxLength={11} placeholder='XXX-XX-XXXX' value={ssn} onChange={(e) => handleInput(e)} />
        </Form.Item>
      </FloatingLabel>
      <p>What is your day of birth?</p>
      <Row gutter={[16, 16]}>
        <Col span={12} md={8} xl={6}>
          <FloatingLabel label='Month' inputId='month' isEdit={isEdit} inputValue={month}>
            <Form.Item
              validateTrigger="onBlur"
              name='month'
              rules={[
                {
                  required: true,
                  validator: (_, value) => check150YearValid(value, 'month', `${month}/${day}/${year}`),
                },
              ]}
              dependencies={['day', 'year']}
            >
              <Input
                id='month'
                value={month}
                name='month'
                onChange={(e) => handleSetMonth(e.target.value.replace(/[^0-9]/g, ''))}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                maxLength={2}
                placeholder='MM'
              />
            </Form.Item>
          </FloatingLabel>
        </Col>
        <Col span={12} md={8} xl={6}>
          <FloatingLabel label='Day' inputId='day' isEdit={isEdit} inputValue={day}>
            <Form.Item
              validateTrigger="onBlur"
              name='day'
              rules={[
                {
                  required: true,
                  validator: (_, value) => check150YearValid(value, 'day', `${month}/${day}/${year}`),
                },
              ]}
              dependencies={['month', 'year']}
            >
              <Input
                id='day'
                value={day}
                name='day'
                onChange={(e) => handleSetDay(e.target.value.replace(/[^0-9]/g, ''))}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                maxLength={2}
                placeholder='DD'
              />
            </Form.Item>
          </FloatingLabel>
        </Col>
        <Col span={24} md={8} xl={6}>
          <FloatingLabel label='Year' inputId='year' isEdit={isEdit} inputValue={year}>
            <Form.Item
              validateTrigger="onBlur"
              name='year'
              rules={[
                {
                  required: true,
                  validator: (_, value) => check150YearValid(handleSetYear(value.replace(/[^0-9]/g, '')), 'year', `${month}/${day}/${year}`),
                },
              ]}
              dependencies={['day', 'month']}
            >
              <Input
                id='year'
                value={year}
                name='year'
                onChange={(e) => handleSetYear(e.target.value.replace(/[^0-9]/g, ''))}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                maxLength={4}
                placeholder='YYYY'
              />
            </Form.Item>
          </FloatingLabel>
        </Col>
      </Row>
      <Form.Item className='auth-form__fixed-submit' shouldUpdate>
        {() => (
          <Button
            type='primary'
            htmlType='submit'
            className='ant-btn-primary--alt'
            loading={loading}
            disabled={!form.isFieldsTouched(true) || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
          >
            Continue <ArrowRight marginLeft='10px' verticalAlign='middle' top='-2px' />
          </Button>
        )}
      </Form.Item>
    </Form>
  );
};

StepThree.propTypes = {
  nextAction: PropTypes.func,
};

export default StepThree;
